import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PricingPlan from "../../PricingPlan/PricingPlan";
import "./AlgoTrading-ad2.css";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

import LandingreadymadeStrategies from "../../../../Images/Images/AlgoTrading-ad2/landingreadymade-strategies.png";
import AllInclusive from "../../../../Images/Images/AlgoTrading-ad2/all-inclusive.png";
import Backtesting from "../../../../Images/Images/AlgoTrading-ad2/backtesting.png";
import Factorrisk from "../../../../Images/Images/AlgoTrading-ad2/Factorriskpng.png"
import Wantalgo from "../../../../Images/Images/AlgoTrading-ad2/want-algo-2.png";
import pricingimg1 from "../../../../Images/Images/AlgoTrading-ad2/pricingimg1.png";

import EarnInterest from "../../../../Images/utilities-menu.png";
import Logo from "../../../../Images/logo.png";
import RoundClock from "../../../../Images/partner-with-us-menu.png";
import Downloadapp from "../../../../Images/landing/landing-download-app.png";
import Playstore from "../../../../Images/playstore.png";
import Appstore from "../../../../Images/appstore.png";
import { useNavigate, useLocation } from "react-router-dom";
const requestIcon = <FontAwesomeIcon icon={faComment} />
const callIcon = <FontAwesomeIcon icon={faPhone} />
const facebook = <FontAwesomeIcon icon={faFacebook} />
const twitter = <FontAwesomeIcon icon={faTwitter} />
const linkedin = <FontAwesomeIcon icon={faLinkedin} />
const instagram = <FontAwesomeIcon icon={faInstagram} />
const angleright = <FontAwesomeIcon icon={faAngleRight} />

// function onChange(value) {
//     console.log("Captcha value:", value);
// }
function AlgoTradingad2() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('')
    const [showText, setShowText] = useState('');
    let pathName = window.location.pathname.split('-')[0];
    let navigate = useNavigate();
    let fullname = /[a-zA-Z][a-zA-Z ]*$/;
    var phoneno = /[0-9]$/;
    var emailvalidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    function onChange(value) {
        setShowText(value)
        // console.log("Captcha value:", value);
    }
    const Validation = (evt) => {

        if (evt.target.id == "Firstname") {
            if (fullname.test(evt.target.value)) {
                setName(evt.target.value)
                // console.log(evt.target.value)
            }

            else {
                if (evt.target.value.length < 1) {
                    setName('')
                }
                else {
                    alert("Please enter valid name")
                }

            }
        }
        else if (evt.target.name == "mobile") {
            if (phoneno.test(evt.target.value)) {
                if (evt.target.value.length < 11) {
                    setMobile(evt.target.value)
                }
                else {
                    alert("Only Enter 10 Digit");
                }
                // console.log(evt.target.value)
            }
            else {
                if (evt.target.value.length < 1) {
                    setMobile('')
                }
                else {
                    alert("Please enter valid contact number")
                }
            }

        }
        else if (evt.target.id == "email") {
            setEmail(evt.target.value.toLowerCase())
        }
    }
    const onsubmiitform = (event) => {
        event.preventDefault();
        if (name != '' && email != '' && mobile != '' && showText != '') {
            if (mobile.length == 10) {
                if (emailvalidation.test(email.toLowerCase())) {

                    const request = {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 'first_name': name, 'email': email, 'mobile': mobile, 'lpage': pathName.replace('/', ''), 'l_page': window.location.pathname.replace("/", "") })
                    }
                    fetch('https://moneysukh.com:8443/crm', request)
                        .then(response => {
                            if (response.ok) {
                                response.json().then(json => {
                                    if (json.dta.contact != undefined) {
                                        // window.location="/ThanksYou"
                                        sendMsg(request)
                                        navigate('/ThanksYou')
                                    }
                                    else {
                                        alert("email id already exists")
                                    }

                                })
                            }
                        })
                        .catch(e => {
                            console.log(e);
                        })
                }
                else {
                    alert("Please enter valid email")
                }
            }
            else {
                alert("Please enter 10 digit")
            }

        }
        else {
            alert("Please enter the all field value")
        }

    }
    const sendMsg = (request) => {
        fetch('https://moneysukh.com:8443/res/send-mail', request)
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        console.log(json);
                    })
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
    return (
        <>
            <div className="algotradingad2_page">
                <section className="landing_header">
                    <div className="container">
                        <div className="landingheader_main">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <div className="landingheader_logo">
                                        <a href="/"> <img className="img-fluid" src={Logo} alt="Logo" /></a>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingheader_text text-right">
                                        <a href="tel:91 9638237000" className="btn callus_header">Call US: 96382-37000</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="algolandinghero_section" id="query_form">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-md-12 col-sm-12 col-xs-12">
                                <div className="algolandinghero_text">
                                    <h2>Are you ready to take your <span> trading</span> to the next level?</h2>
                                    {/* <p>
                                    Algo trading assists an investor<small>/</small>trader in overcoming his emotional quotient, removing trading biases and emotional backlogs, and putting trades on the terminal at lightning speed, reducing manual invention. 
                                         </p> */}
                                   <div className="row">
                                    <div className="col-sm-4">
                                        <div className="heroalgotrading_poingroup">
                                        <div className="heroalgotrading_pointbox">
                                        <h3 className="heroalgotrading_heading">Fully Automated Trading</h3>
                                    </div>
                                    </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="heroalgotrading_poingroup">
                                        <div className="heroalgotrading_pointbox pretested">
                                        <h3 className="heroalgotrading_heading">Backtested 200+ Strategies</h3>
                                    </div>
                                    </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="heroalgotrading_poingroup">
                                        <div className="heroalgotrading_pointbox createownstrgy">
                                        <h3 className="heroalgotrading_heading">Create Your Own Strategies</h3>
                                    </div>
                                    </div>
                                    </div>
                                    
                                   </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-md-12 col-sm-12 col-xs-12">
                                <div className="landingqueryform_main">
                                    <div className="landing_queryform">
                                        <h3>Open Demat Account</h3>
                                        <form className="landing_form" onSubmit={onsubmiitform}>
                                            <div className="form-group">
                                                <label htmlFor="Firstname">Name <span className="required-mark-label">*</span></label>
                                                <input type="text" className="form-control" id="Firstname" aria-describedby="Firtname" placeholder="Name" onChange={(e) => Validation(e)} value={name} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="email">Email id <span className="required-mark-label">*</span></label>
                                                <input type="text" className="form-control" id="email" aria-describedby="email" placeholder="email" onChange={(e) => Validation(e)} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="mobile">Mobile <span className="required-mark-label">*</span></label>
                                                <input type="text" name="mobile" id="mobile" placeholder="Mobile No." onChange={Validation} value={mobile
                                                } />
                                            </div>
                                            <div className="form-group">
                                                <div className="captcha_panel text-white">
                                                    <ReCAPTCHA
                                                        sitekey="6Ld081AjAAAAAB-cDElsSSUot-5w0WtXA_XY3YrS"
                                                        onChange={onChange}
                                                    />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn btn-primary">Apply Now</button>
                                        </form>
                                        <p>For Existing Clients <a href="https://learn.moneysukh.com/existing-client/">Click Here</a>.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="platform-feature">
                    <div className="savefeature-block__wrapper">
                    <div className="container-fluid">
                        <div className="landingpage_heading">
                            <h2>Why Algo Trading? </h2>
                        </div>
                        </div>
                        <div className="platformfeature_area">
                            <div className="platformfeature_grid">
                                <div className="platformfeature_group">
                                <div className="container">
                                <div className="row align-items-center">
                                <div className="col-sm-6">
                                <div className="platformfeature_img">
                                <img src={AllInclusive} className="img-fluid"/>
                                </div>
                                </div>
                                        <div className="col-sm-6">
                                            <div className="platformfeature_card card-1">
                                            <h2> Algo Trading Features</h2>
                                                <ul>
                                                    <li>Real Time Trade and Analysis</li>
                                                    <li>Reduce transaction cost</li>
                                                    <li>Best solution for working people who can't spend time in market </li>
                                                </ul>
                                                <a className="common_btn" href="#query_form">Open your Account {angleright}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div className="platformfeature_group">
                                <div className="container">
                                <div className="row align-items-center factorriks_row">
                                        <div className="col-sm-6">
                                            <div className="platformfeature_card card-1">
                                            <h2> Factor in the risk</h2>
                                                <ul>
                                                    <li>Reduce risk of manual errors while placing trade </li>
                                                    <li>Reduce the possibility of mistakes by human trade based on emotional and psychological factors</li>
                                                    <li>Algo trading can be backtest using historical and real time data</li>
                                                </ul>
                                                <a className="common_btn" href="#query_form">Open your Account {angleright}</a>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                <div className="platformfeature_img">
                                <img src={Factorrisk} className="img-fluid"/>
                                </div>
                                </div>                 
                                    </div>
                                </div>
                            </div>
                            <div className="platformfeature_group">
                                <div className="container">
                                <div className="row align-items-center">
                                <div className="col-sm-6">
                                <div className="platformfeature_img">
                                <img src={pricingimg1} className="img-fluid"/>
                                </div>
                                </div>
                                        <div className="col-sm-6">
                                            <div className="platformfeature_card card-1">
                                            <h2> Zero Charges</h2>
                                            <ul>
                                                <li>0 Account Maintenance Charges</li>
                                                <li>0 Charges for Research tools</li>
                                                <li>0 Charges for Delivery</li>
                                                <li>Flexible brokerage plans</li>
                                            </ul>
                                                <a className="common_btn" href="#query_form">Open your Account {angleright}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                               
                            </div>
                        </div>
                    </div>
                </section>

                <section className="haveyourstrategy_ctasection"><div className="haveyourstrategy_wrapper">
                    <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-7 ">
                            <h2>Want to try Algo trading <br></br>first time?</h2>
                            <p>Connect With Us To Use It </p>
                            <div className="btn_actionlink"><a href="#query_form">Request call back</a></div>
                        </div>

                        <div className="col-sm-5">
                        <div className="haveyourstrategy_img text-center">
                            <img className="img-fluid" alt="Have your own strategy let us help you"  src={Wantalgo} />
                            </div>
                            </div>
                    </div>
                </div>
                </div>
                </section>

                <section className="landing_footer">
                    <div className="container">
                        <div className="landingfooter_main">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="landingfooter_contact">
                                        <div className="landingpage_heading"><h2>For Any Query</h2></div>
                                        <ul className="landingfooter_nav">
                                            <li><a href="tel:96382-37000">Call us on : 96382-37000</a></li>
                                            <li><a href="mailto:sales@moneysukh.com">Email : sales@moneysukh.com</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingfooter_connect text-center">
                                        <div className="landingpage_heading"><h2>Connect</h2></div>
                                        <div className="landing_socialmedia">
                                            <a href="https://www.facebook.com/Moneysukh"><span>{facebook}</span></a>
                                            <a href="https://twitter.com/moneysukhonline"><span>{twitter}</span></a>
                                            <a href="https://www.linkedin.com/company/mansukh-securities-&-finance-ltd./"><span>{linkedin}</span></a>
                                            <a href="https://www.instagram.com/moneysukhofficial/"><span>{instagram}</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="landing_disclaimer text-center"><a href="/Disclaimer">Disclaimer*</a></p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default AlgoTradingad2;